export const isEmailDomainValid = (emailDomain: string) => {
    if (/@\S+\.\S+/.test(emailDomain)) {
        return true;
    }
    return false;
};

export enum CustomerAccessGroupMode {
    Default = "Default",
    GroupOnly = "GroupOnly"
};
